// store/index.js
import Vue from 'vue';
import Vuex from 'vuex';
import auth from './modules/auth';
import createPersistedState from 'vuex-persistedstate';
Vue.use(Vuex);

const sanitizePersistedAuth = () => {
	try {
		const raw = window.localStorage.getItem('vuex');
		if (!raw) {
			return;
		}
		const data = JSON.parse(raw);
		if (data && data.auth && Object.prototype.hasOwnProperty.call(data.auth, 'password')) {
			delete data.auth.password;
			window.localStorage.setItem('vuex', JSON.stringify(data));
		}
	} catch (error) {
		// ignore
	}
};

sanitizePersistedAuth();

export default new Vuex.Store({
	modules: {
		auth
	},
	plugins: [
		createPersistedState({
			storage: window.localStorage, // 使用 localStorage 来持久化数据
			paths: ['auth.isAuthenticated', 'auth.user', 'auth.username', 'auth.storeId'] // 仅持久化 auth 安全字段
		})
	]
});
